// components/common/CollapsibleSection.jsx
import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

const CollapsibleSection = ({
  title,
  subtitle,
  collapsed,
  setCollapsed,
  children,
  rightContent
}) => (
  <div className="bg-white rounded-xl shadow-sm border border-grey-200 overflow-hidden">
    <button
      onClick={() => setCollapsed(!collapsed)}
      className="w-full px-4 py-3 sm:px-5 sm:py-4 md:px-6 hover:bg-grey-50 transition-colors"
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <ChevronRightIcon className={`w-4 h-4 text-grey-500 flex-shrink-0 transition-transform duration-200 ${!collapsed ? 'rotate-90' : ''}`} />
          <div className="text-left min-w-0">
            <h2 className="text-sm sm:text-base font-semibold text-darkblue-500">
              {title}
            </h2>
            {subtitle && (
              <p className="text-xs text-grey-500 mt-0.5 line-clamp-1">
                {subtitle}
              </p>
            )}
          </div>
        </div>

        {rightContent && (
          <div
            className="hidden sm:flex items-center flex-shrink-0"
            onClick={(e) => e.stopPropagation()}
          >
            {rightContent}
          </div>
        )}
      </div>
    </button>

    {!collapsed && rightContent && (
      <div className="sm:hidden px-4 py-3 bg-grey-50 border-t border-grey-200">
        {rightContent}
      </div>
    )}

    {!collapsed && (
      <div className="px-4 py-4 sm:px-5 md:px-6 border-t border-grey-100">
        {children}
      </div>
    )}
  </div>
);

export default CollapsibleSection;